import * as React from 'react';

export const noFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_no)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#BA0C2F'
            />
            <mask
                id='mask0_1_no'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_no)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H0V8H8V0H12V8H28V12H12V20H8V12Z'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M9.33333 9.33333H0V10.6667H9.33333V20H10.6667V10.6667H28V9.33333H10.6667V0H9.33333V9.33333Z'
                    fill='#00205B'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_no'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
